export default __webpack_public_path__ + "static/woman-magazine-e17755b6acbd35e71013bb2cc61f3f2f.png";